import { useQuery } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { GetEventSettingsDto } from '@/types/dtos/events/response/get-event-settings.dto.ts';

export const GET_EVENT_SETTINGS_QUERY_KEY = 'getEventSettings';

export const useGetEventSettingsQuery = (eventId?: string) => {
  const { getToken } = useAuth();

  return useQuery({
    queryKey: [GET_EVENT_SETTINGS_QUERY_KEY, eventId],
    queryFn: async () => {
      if (!eventId) return null;
      const token = await getToken();
      return getEventSettings(eventId, token ?? '');
    },
    enabled: !!eventId,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: false, // Don't retry on failure
  });
};

const getEventSettings = async (eventId: string, token: string): Promise<GetEventSettingsDto> => {
  const url = `${import.meta.env.VITE_API_URL}/events/${eventId}/settings`;
  return sendJSONRequest({
    url,
    method: METHOD.GET,
    token,
  });
};
